
const blogPosts = document.querySelectorAll(".blog-posts__grid .article-item");
var isAlreadyViewed = {1: false, 2: false, 3: false};
if(blogPosts){
    // Datalayer after viewing articles
    document.addEventListener('scroll', (event) => {
        blogPosts.forEach((article, index) => {
            const blog = article.dataset.blog;
            if(blog == 'promotions'){
                const elementRect = article.getBoundingClientRect();
                // Check if article is visible in the viewport 
                const isVisible = (
                    elementRect.top >= 0 &&
                    elementRect.left >= 0 &&
                    elementRect.bottom <= (window.innerHeight ||
                    document.documentElement.clientHeight) &&
                    elementRect.right <= (window.innerWidth || 
                    document.documentElement.clientWidth)
                );
                if(isVisible && !isAlreadyViewed[index+1]){
                    article.dataset.slot = 'slot'+(index+1);
                    gtm_datalayer('promo_view_carousel', article);
                    isAlreadyViewed[index+1] = true;
                }
            }
        });
    });
    // datalayer after clicking on article
    blogPosts.forEach((article, index) => {
        const blog = article.dataset.blog;
        if(blog == 'promotions'){
            const links = article.querySelectorAll("a");
            if(links){
                links.forEach((link) => {
                    link.addEventListener('click', () => {
                        link.dataset.id = article.dataset.id;
                        link.dataset.name = article.dataset.name;
                        link.dataset.slot = 'slot'+(index+1);
                        gtm_datalayer('promo_click_carousel', link);
                    });
                });
            }
        }
    });
}

const megaNavPromotions = document.querySelector("li.promotions");
if(megaNavPromotions){
    const links = megaNavPromotions.querySelectorAll("h4 a");
    if(links){
        links.forEach((link, index) => {
            link.addEventListener('click', () => {
                link.dataset.slot = 'slot'+(index+1);
                gtm_datalayer('promo_click_menu', link);
            });
        });
    }
}